<template name="dateTemplate" lang="html">
    <div class="row">
        <b-loading :is-full-page="isFullPage" :active.sync="isLoading" :can-cancel="true"></b-loading>
        <div id="sidebarMenu" class="sidebar sidebar-fixed bg-white">
            <div class="sidebar-header">
                <h5>Search</h5>
                <a href="" id="sidebarMenuClose"><i data-feather="x"></i></a>
            </div><!-- df-sidebar-header -->
            <div class="sidebar-body">
                <ul class="sidebar-nav" v-for="(form, i) in inputSearchForms">
                    <li class="nav-label mg-b-10-f" v-if="i === 0">Input Search</li>
                    <div class="form-group">
                        <label for="formGroupExampleInput" class="d-block">{{form.name}}</label>
                        <input type="text" v-on:keyup="textKeyupEvent" class="form-control" v-model="form.value" :id="form.id" :placeholder="form.name">
                    </div>
                </ul>
                <ul class="sidebar-nav mg-t-35-f" v-for="(form, i) in dateSearchForms">
                    <li class="nav-label mg-b-10-f" v-if="i === 0">Date Search</li>
                    <label for="formGroupExampleInput" class="d-block">{{form.name}}</label>
                    <li class="nav-item">
                        <date-picker @dp-change="dateKeyupEvent" v-model="form.fvalue" :config="datePickerOptions" class="form-control" autocomplete='off' placeholder="From date" :id="form.fid" aria-label="Search" ignoreReadonly />
                    </li>
                    <li class="nav-item">
                        <date-picker @dp-change="dateKeyupEvent" v-model="form.evalue" :config="datePickerOptions" class="form-control" autocomplete='off' placeholder="To date" :id="form.eid" aria-label="Search" ignoreReadonly />
                    </li>
                </ul>
                <ul class="sidebar-nav mg-t-35-f" v-for="(form, i) in checkboxSearchForms">
                    <li class="nav-label mg-b-10-f" v-if="i === 0">Checkbox Search</li>
                    <label for="formGroupExampleInput" class=" d-block">{{form.name}}</label>
                    <div class="custom-control custom-checkbox mg-b-7" :id="form.id" v-for="(form1, i) in form.subs">
                        <input type="checkbox" v-on:click="checkClickEvent" class="custom-control-input" :id="form1.codeCode" :value="form1.codeCode">
                        <label class="custom-control-label" :for="form1.codeCode">{{form1.codeName}}</label>
                    </div>
                </ul>

            </div><!-- sidebar-body -->
        </div><!-- sidebar -->
        <div class="content content-components">
            <div class="pd-x-0 pd-lg-x-10 pd-xl-x-0">
                <div class="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
                    <div>
                        <nav aria-label="breadcrumb">
                            <ol class="breadcrumb breadcrumb-style1 mg-b-10">
                                <li class="breadcrumb-item">{{this.mainName}}</li>
                                <li class="breadcrumb-item active" aria-current="page">{{this.subName}} List</li>
                            </ol>
                            <h4 class="mg-b-0 tx-spacing--1">{{this.subName}} List</h4>
                        </nav>
                    </div>
                </div>
                <div class="row row-xs">
                    <div class="col-lg-12 mg-t-10">
                        <section>
                            <b-field grouped group-multiline>
                                <b-select v-model="perPage" :disabled="!isPaginated">
                                    <option value="20">20</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                    <option value="200">200</option>
                                </b-select>
                            </b-field>
                        </section>
                        <section>
                             <div class="d-none d-md-block tx-right-f">
                                <a href="#modal2" @click="" class="btn btn-xs pd-x-15 btn-secondary btn-uppercase mg-l-5 mg-y-9-f" data-toggle="modal" data-animation="effect-flip-horizontal"><feather type="plus-circle" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>ADD</a>
                            </div>
                            <b-table :data="isEmpty ? [] : data" :loading="loading" paginated hoverable striped backend-pagination :total="total" :per-page="perPage" @page-change="onPageChange" aria-next-label="Next page" aria-previous-label="Previous page" aria-page-label="Page" aria-current-label="Current page" backend-sorting :default-sort="[sortField, sortOrder]" @sort="onSort">
                                <template slot-scope="props">
                                    <b-table-column v-for="(form, i) in headers" v-if="form.columnAttr == 'runid'" :key="i" :field="form.columnAttr" :label="form.columnName" centered sortable><a href='#' @click='classifySample(props.row.id)'>{{ props.row[form.columnAttr] }}</a>
                                    </b-table-column>
                                    <b-table-column v-else :key="i" :field="form.columnAttr" :label="form.columnName" centered sortable>{{ props.row[form.columnAttr] }} </b-table-column>
                                </template>
                                <template slot="empty">
                                    <section class="section">
                                        <div class="content has-text-grey has-text-centered">
                                            <p>Nothing here.</p>
                                        </div>
                                    </section>
                                </template>
                            </b-table>
                        </section>
                    </div><!-- col -->
                </div><!-- row -->
            </div><!-- container -->
            <div class="pd-x-0 pd-lg-x-10 pd-xl-x-0">
                <div class="row row-xs">
                    <div class="col-lg-12 mg-t-10">
                        <section>
                            <!-- run and pre !-->
                             <div class="d-none d-md-block tx-right-f" v-if="datacolumns.length > 0 ">
                                <a href="" @click="excelExport()" class="btn btn-xs pd-x-15 btn-secondary btn-uppercase mg-l-5 mg-y-9-f" data-toggle="modal" data-animation="effect-flip-horizontal"><feather type="file-text" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>Excel</a>
                            </div>
                            <ul id="myTab5" role="tablist" v-if="datacolumns.length > 0 " class="nav nav-line">
                                <li class="nav-item" v-for="(form, i) in tabHeaders" v-if="properties.mid === form.id"><a class="nav-link active" @click='classifySampleHeader(form.id,form.jobOrder)' :id="form.id" data-toggle="tab" href="#" role="tab" aria-controls="home" aria-selected="true">{{form.menuName}}</a></li>
                                <li class="nav-item" v-else-if="form.jobOrder != 6" ><a class="nav-link" @click='classifySampleHeader(form.id,form.jobOrder)' :id="form.id" data-toggle="tab" href="#" role="tab" aria-controls="profile" aria-selected="false">{{form.menuName}}</a></li>
                            </ul>
                            <div class="">
                                <div class="" style="white-space:nowrap; overflow-x:scroll;">
                                    <b-table :data="items" hoverable striped paginated per-page="15">
                                        <template slot-scope="props">
                                            <b-table-column v-for="(form, i) in datacolumns" v-if="form.field == 'receptionno'" :key="i" :field="form.field" :label="form.label" centered sortable><a href='#modal52' data-toggle="modal" data-animation="effect-flip-horizontal" @click='sendId(props.row.receptionId)'> {{ props.row[form.field] }} </a></b-table-column>
                                            <b-table-column v-else-if="form.field == 'report'" :key="i" :field="form.field " :label="form.label" centered sortable>
                                                [<a href="#" @click="toReport(props.row.name,1)">Forward</a>]&nbsp;&nbsp;&nbsp;&nbsp;[<a href="#" @click="toReport(props.row.name,2)">Reverse</a>]
                                                </b-table-column>
                                            <b-table-column v-else :key="i" :field="form.field" :label="form.label" centered sortable>{{ props.row[form.field] }}</b-table-column>
                                        </template>
                                    </b-table>
                                </div>
                            </div>
                        </section> <!-- run and pre !-->
                    </div>
                </div>
            </div>
        </div><!-- content -->
        <div class="modal fade" id="modal52" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel52" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered chat-width" role="document">
                <div class="modal-content tx-14 chat-height">
                    <div class="modal-header">
                        <h6 class="modal-title" id="exampleModalLabel52">Chat</h6>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <Chat></Chat>
                    </div>
                </div>
            </div>
        </div><!-- chat modal -->

        <div class="modal fade" id="modal2" tabindex="-1" role="dialog" aria-labelledby="limitModal" aria-hidden="true">
			<div class="modal-dialog modal-dialog-centered" style="max-width:570px;" role="document">
				<div class="modal-content tx-14">
					<div class="modal-header">
						<h6 class="modal-title" id="limitModal">ADD DATA</h6>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<div class="row row-xs mt-1 d-block">
							<div class="list-group overflow-auto">
                                <label class="is-pulled-left">• Run ID</label>
                                    <b-field
                                        :type="runIdChkType"
                                        :message="runIdChkMsg">
                                        <b-input
                                            v-model="runId"
                                            placeholder="Run Id.."
                                            @click="resetInput('runId')"
                                        ></b-input>
                                    </b-field>
                                <div class="d-none d-md-block tx-right-f mg-xs-y-15-f">
                                    <label class="is-pulled-left">• File Path</label>
                                    <!-- <b-button size="is-small" >Check</b-button> -->
                                    <b-button
                                        :loading="inputCheckLoading"
                                        plain
                                        size="is-small"
                                        @click="inputCheck(runId,filePath)">
                                        Check
                                    </b-button>
                                    <!-- <b-button="" class="btn btn-xs pd-x-15 btn-secondary btn-uppercase mg-l-5" data-toggle="modal" data-animation="effect-flip-horizontal"><feather type="minus" class="wd-10 mg-r-5 svg_overflow"></feather>Delete</b-button> -->
                                </div>
                                <b-field
                                    :type="pathChkType"
                                    :message="pathChkMsg">
                                    <b-input
                                        v-model="filePath"
                                        placeholder="ex) /data/.."
                                        @click="resetInput('filePath')"
                                    ></b-input>
                                </b-field>
							</div>
						</div>
                        <!-- <v-card  height="300px" class="scroll">
                            <v-treeview
                                v-model="tree"
                                :items="dir"
                                activatable
                                item-key="name"
                                open-on-click
                                color="warning"
                            >
                                <template v-slot:prepend="{ item, open }">
                                    <v-icon v-if="!item.file">
                                        {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
                                    </v-icon>
                                    <v-icon v-else>
                                        {{ files[item.file] }}
                                    </v-icon>
                                </template>
                            </v-treeview>
                        </v-card> -->
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary tx-13" data-dismiss="modal">Close</button>
						<button type="button" class="btn btn-primary tx-13" v-on:click="createData()">SAVE</button>
					</div>
				</div>
			</div>
		</div>
    </div>
</template>
<script>
/* 날짜 입력을 위한 외부 라이브러리 import */
import datePicker from "vue-bootstrap-datetimepicker";
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
import moment from "moment";

// 공통 스크립트
import common from "@/views/Common/common.js";
// Header의 메뉴 정보 호출을 위한 bus event
import { bus } from "../../../main";
import Chat from "@/views/Common/Chat";
import excel from '@/views/Common/excel.js';

export default {
    name: "List",
    props: ["properties"],
    data() {
        return {
            datacolumns: [],
            items: [],
            tabHeaders: [],
            sampleData: [],
            scrollable : true,

            // date setting
            datePickerOptions: {
                format: "YYYY-MM-DD",
                useCurrent: false,
                showTodayButton: true,
                keepInvalid: false,
                ignoreReadonly: true
            },

            menuData: [],
            mid: "",
            rid: "",

            // menu name
            mainName: "",
            subName: "",
            // items: [],
            // list data
            headers: [],
            details: [],
            data: [],
            isEmpty: false,
            isPaginated: true,
            total: 0,
            loading: false,
            sortField: "",
            sortOrder: "",
            page: 1,
            perPage: 20,

            isLoading: false,
            isFullPage: true,

            // Search data
            inputSearchForms: [],
            dateSearchForms: [],
            checkboxSearchForms: [],

            runId : "",
            filePath : "/data/lims/device/demultiplex/MiSeqDx01/",

            inputCheckLoading: false,
            pathChkType : "normal",
            pathChkMsg : " ",
            runIdChkType : "normal",
            runIdChkMsg : " "
            
        };
    },
    beforeDestroy() {
        bus.$off("menu_data");
    },
    created() {},
    mounted() {
        bus.$on("menu_data", data => {
            this.menuData = data;
            this.classifyHeader();
        });
    },
    methods: {
        /*
        * keyup search
        */
        textKeyupEvent() {
            this.classifyData();
        },
        dateKeyupEvent(e) {
            if (e.oldDate != null) this.classifyData();
        },
        checkClickEvent(e) {
            this.classifyData();
        },
        resetInput(value) {
            console.log(value)
        },
    
        /*
            * Load Headers
            */
        async classifyHeader() {
            let data = common.menuHeader(this.properties.mid, this.menuData, 1);
            this.mainName = data[0];
            this.subName = data[1];
            this.headers = data[3];
            let detailCol = common.menuHeader(this.properties.mid, this.menuData, 2);
            let tabHeader = common.tabOrder(this.properties.mid, this.menuData);

            this.details = detailCol[3];
            this.tabHeaders = tabHeader;

            this.createSearchForm();
            this.classifyData();
        },
        /*
            * search form create
            */
        createSearchForm() {
            this.inputSearchForms = [];
            this.dateSearchForms = [];
            this.checkboxSearchForms = [];
            for (let i in this.headers) {
                if (this.headers[i].columnType == "LIST") {
                    this.checkboxSearchForms.push({
                        name: this.headers[i].columnName,
                        value: [],
                        subs: this.headers[i].code,
                        id: this.headers[i].columnCode
                    });
                } else if (this.headers[i].columnType == "DATE") {
                    this.dateSearchForms.push({
                        name: this.headers[i].columnName,
                        id: this.headers[i].columnCode,
                        fvalue: "",
                        evalue: "",
                        fid: "f_" + this.headers[i].columnCode,
                        eid: "e_" + this.headers[i].columnCode
                    });
                } else if (this.headers[i].columnType == "RANGE") {
                } else if (this.headers[i].columnType == "COUNT") {
                } else {
                    if (this.headers[i].columnName != "No") {
                        this.inputSearchForms.push({
                            name: this.headers[i].columnName,
                            value: "",
                            id: this.headers[i].columnCode
                        });
                    }
                }
            }
        },
        /*
            * Run Info Running Data
            */
        async classifyData() {
            console.log('data')
            this.isLoading = true;
            var params = [];
            params = { mid: this.properties.mid };

            if (this.sortField) params["sortName"] = this.sortField;
            if (this.sortOrder) params["sortOrder"] = this.sortOrder;

            // input type
            for (let i in this.inputSearchForms) {
                if (this.inputSearchForms[i].value) {
                    params[this.inputSearchForms[i].id] = this.inputSearchForms[i].value;
                }
            }
            // // date type
            for (let i in this.dateSearchForms) {
                if (this.dateSearchForms[i].fvalue || this.dateSearchForms[i].evalue) {
                    params[this.dateSearchForms[i].id] =this.dateSearchForms[i].fvalue +"," +this.dateSearchForms[i].evalue;
                }
            }
            // check box type
            for (let i in this.checkboxSearchForms) {
                let inputKey = this.checkboxSearchForms[i].id;
                let checkValueStr = [];
                for (let j in this.checkboxSearchForms[i].subs) {
                    let checkid = this.checkboxSearchForms[i].subs[j].codeCode;
                    if ($("#" + checkid).is(":checked")) {
                        checkValueStr[i] = checkValueStr.length > 0 ? checkValueStr[i].concat(",", $("#" + checkid).val()) : $("#" + checkid).val();
                    }
                }
                if (checkValueStr[i]) {
                    params[inputKey] = checkValueStr[i];
                }
            }
            var request = { params: params };
            this.loading = true;

            await this.$axios.get(this.$apiHost + "/" + this.$route.name + "/search", request).then(res => {
            // api.themoviedb.org manage max 100 pages
            this.data = [];
            
            let currentTotal = res.data.length;
            if (res.data.length / this.perPage > 100) {
                currentTotal = this.perPage * 100;
            }
            this.total = currentTotal;
            for (let i in res.data) {
                // res.data[i].no = res.data.length - Number(i);
                this.headers.find(header =>{
                    for(let j in res.data[i]){
                        if(res.data[i][j] != null){
                            if(header.columnAttr == j){
                                if(!isNaN(res.data[i][j])){
                                    res.data[i][`${j}`] = res.data[i][j].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                                }
                            }
                        }
                    }
                })
                this.data.push(res.data[i]);
            }
            this.loading = false;
            this.isLoading = false;
            }).catch(error => {
                this.data = [];
                this.total = 0;
                this.loading = false;
                throw error;
            });
        },
        /*
            * Run Info This Step Header & Data
            */
        async classifySample(rid) {
            console.log(rid)
            this.isLoading = true;
            this.rid = rid;
            let col = {};
            let row = [];
            let detailData = [];
            let mid = this.properties.mid;

            if (this.datacolumns.length > 0) this.datacolumns.splice(0);
            if (this.items.length > 0) this.items.splice(0);

            await this.$axios.get(this.$apiHost + "/" + this.$route.name + "/detail", {
                params: { menuId : mid ,runId: rid }
            }).then(res => {
                detailData = res.data;
            }).catch(error => {
                throw error;
            });
            this.items = detailData;
            

            let detailCol = common.menuHeader(this.properties.mid, this.menuData, 2);
            this.datacolumns.push({ field: "no", label: 'No' });
            this.datacolumns.push({ field: "receptionno", label: '접수번호' });
            this.datacolumns.push({ field: "receptionname", label: '접수명' });
            this.datacolumns.push({ field: "duedate", label: '완료예정일(TAT)' });
            this.datacolumns.push({ field: "name", label: 'Sample No' });
            this.datacolumns.push({ field: "report", label: 'Report' });
            this.datacolumns.push({ field: "barcode", label: 'Barcode' });
            
            for(let i in detailCol[3]){
                this.datacolumns.push({field: detailCol[3][i].columnAttr, label: detailCol[3][i].columnName})
            }

            for (let i in this.items) {
                this.datacolumns.find(datacolumn =>{
                    for(let j in this.items[i]){
                        if(this.items[i][j] != null){
                            if(datacolumn.field == j){
                                if(!isNaN(this.items[i][j])){
                                    this.items[i][`${j}`] = this.items[i][j].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                                }
                            }
                        }
                    }
                })
            }
            
            this.isLoading = false;
        },
            /*
            * Run Info Prep Step Header
            */
        async classifySampleHeader(mid,jobOrder) {
            console.log(jobOrder)
            console.log(mid)
            this.datacolumns = [];
            if (this.datacolumns.length > 0) this.datacolumns.splice(0);
            if (this.items.length > 0) this.items.splice(0);

            let datacolumns = [];
            let thisMid = common.isNull(event.target.id) ? this.properties.mid : event.target.id;
            let premid = common.preMid(this.properties.mid, this.menuData);
            let preCol = common.AllHeader(premid, this.menuData, 1);

            // if (thisMid == this.properties.mid) {
            //     this.classifySample(this.rid)
            //     return false;
            // }

            // datacolumns = preCol[1];
            
            let detailColumns = []
            let headerColumns = []
            
            if(jobOrder == 7){
                this.classifySample(this.rid)
                return false;
            }else{
                this.datacolumns.push({ field: "no", label: 'No' });
                if(jobOrder == 1){
                    detailColumns = common.menuHeader(mid, this.menuData, 1)[3]
                }else{
                    this.datacolumns.push({ field: "receptionno", label: 'Reception No' });
                    this.datacolumns.push({ field: "sampleid", label: 'Sample No' });
                    this.datacolumns.push({ field: "barcode", label: 'Barcode' });
                    headerColumns = common.menuHeader(mid, this.menuData, 1)[3]
                    detailColumns = common.menuHeader(mid, this.menuData, 2)[3]
                }
            }

            headerColumns.forEach((a,b) => {
                this.datacolumns.push({field: a.columnCode, label: a.columnName});
            });

            detailColumns.forEach((a,b) => {
                this.datacolumns.push({field: a.columnCode, label: a.columnName});
            });
            this.classifySampleData(mid);
        },
        /*
            * Run Info Prep Step Data
            */
        async classifySampleData(thisMid) {
            this.isLoading = true;
            
            let row = [];
            let rs_data = [];
            let detailData = [];

            await this.$axios.get(this.$apiHost + "/" + this.$route.name + "/step", {
                params: { rid: this.rid, stepid: thisMid, mid: this.properties.mid  }
            }).then(res => {
                detailData = res.data
            }).catch(err => {
                console.log(err);
            });
        
            this.items = detailData;
            this.isLoading = false;
        },
        /*
            * Handle page-change event
            */
        onPageChange(page) {
            this.page = page;
            this.classifyData();
        },
        /*
            * Handle sort event
            */
        onSort(field, order) {
            this.sortField = field;
            this.sortOrder = order;
            this.classifyData();
        },
        async inputCheck (runId, filePath) {
           this.inputCheckLoading = true;
            // setTimeout(() => {
            //         this.isLoading = false
            //     }, 10 * 1000)
            
            const request = { params: {runId : runId, filePath: filePath} };
            let pathBoolean = false;
            let runidBoolean = false;
            let run = {};
            await this.$axios.get(this.$apiHost + "/" + this.$route.name + "/check", request).then(res => {
                console.log(res.data)
                pathBoolean = res.data.pathExist;
                runidBoolean = res.data.runExist;
                if(runidBoolean){
                    run = res.data.run;
                }
            }).catch(error => {
                throw error;
            });
            if(filePath.length == 0){
                this.inputCheckLoading = false;
                this.pathChkMsg = "경로를 입력하지 않았습니다."
                this.pathChkType = "is-danger"
                
            }else{
                if(pathBoolean){
                    this.pathChkMsg = "사용 가능한 경로입니다.";
                    this.pathChkType = "is-success";
                }else{
                    this.pathChkMsg = "잘못된 경로입니다.";
                    this.pathChkType = "is-danger";
                }
            }

            if(runId.length == 0){
                this.inputCheckLoading = false;
                this.runIdChkMsg = "Run ID를 입력하지 않았습니다.";
                this.runIdChkType = "is-danger";
                
            }else{
                if(runidBoolean){
                    console.log(runidBoolean)
                    this.runIdChkMsg = "Run Id가 중복입니다.( Run Id : "+run.runId+", 일시 : "+run.createDate+" )";
                    this.runIdChkType = "is-danger";
                }else{
                    this.runIdChkMsg = "사용 가능한 Run Id 입니다.";
                    this.runIdChkType = "is-success";
                }
            }
            this.inputCheckLoading = false;
        },
        async createData(){

            if(this.runId.trim().length == 0 && this.filePath.trim().length == 0 ){
                this.$buefy.dialog.alert({
                        message: '값이 입력되지 않았습니다.',
                        size: 'is-medium',
                        type: 'is-danger'
                });
                return false;
            }else if(this.runId.trim().length == 0 ){
                this.$buefy.dialog.alert({
                        message: 'Run Id를 입력하세요.',
                        size: 'is-medium',
                        type: 'is-danger'
                });
                return false;
            }else if(this.filePath.trim().length == 0 ){
                this.$buefy.dialog.alert({
                        message: 'Path 를 입력하세요.',
                        size: 'is-medium',
                        type: 'is-danger'
                });
                return false;
            }else if (this.data.findIndex(find => {return this.runId == find.runId}) != -1){
                this.$buefy.dialog.alert({
                        message: 'Run Id가 존재합니다.',
                        size: 'is-medium',
                        type: 'is-danger'
                });
                return false;
            }else{
                if(this.pathChkType == 'normal'){
                    this.$buefy.dialog.alert({
                        message: '경로 확인이 필요합니다.',
                        size: 'is-medium',
                        type: 'is-danger'
                    });
                    return false;
                }else if(this.pathChkType == 'is-danger'){
                    this.$buefy.dialog.alert({
                        message: '잘못된 경로입니다.',
                        size: 'is-medium',
                        type: 'is-danger'
                    });
                    return false;
                }else{
                    const request = {
                        runId : this.runId,
                        path : this.filePath
                    }
                    this.$buefy.dialog.confirm({
                        message: "<p>저장 하시겠습니까?</p><p>저장한 이후에는 변경 할 수 없습니다.</p>",
                        size: 'is-medium',
                        onConfirm: async () => {
                            this.isLoading = true;
                            let message = "";
                            await this.$axios.post(this.$apiHost + "/" + this.$route.name , request).then(res => {
                                message = res.data.message
                                
                            }).catch(error => {
                                throw error;
                            });
                            if (message == "ADD_SUCS"){
                                this.$buefy.dialog.alert({
                                    message: "저장하였습니다.",
                                    size: 'is-medium',
                                });
                                this.$router.go({name:this.$route.name});
                                this.isLoading = false;
                            }else if(message == "CHNG_FAIL"){
                                this.$buefy.dialog.alert({
                                    message: "저장에 실패하였습니다.",
                                    size: 'is-medium',
                                });
                                this.$router.go({name:this.$route.name});
                                this.isLoading = false;
                            }
                        }
                    });
                }
            }
            
        },
        async toReport(name, num) {
            
            // window.open("https://lims.accugenelab.com/pdf/test_2020121410090_서o춘.pdf")
            console.log(this.rid)
            await this.$axios.get(this.$apiHost + "/" + this.$route.name + "/report", {
                params: { headerId : this.rid, name: name, read: num }
                })
                .then(res => {
                
                if (res.data.message == "EXIST") {
                    window.open("http://lims.accugenelab.com:1080"+res.data.path.path)
                } else {
                    window.alert("Report did created not yet.");
                }
                })
                .catch(error => {
                throw error;
                });
            },
        async authCheck(cid) {
            var auth_bol = false;
            await this.$axios.get(this.$apiHost + "/", { params: { creatorId: cid } }).then(res => {
                auth_bol = res.data.results;
            }).catch(err => {
                console.log(err);
            });
            return auth_bol;
        },
        sendId(id){
            bus.$emit("receptid", id);
        },
        excelExport(){ 
            excel.excelExportDataParser(this.items, this.datacolumns);
        },
    },
    components: {
        datePicker,
        moment,
        Chat
    },
    computed: {},
    watch: {}
};
</script>
<style scoped>
@import "../../../assets/css/buefy.css";
</style>


// WEBPACK FOOTER //
// src/views/Sequencing/Demultiplex/List3.vue